import * as actionTypes from './actionTypes';

export const fetchAccountAgreementData = payload => ({
	type: actionTypes.fetchAccountDataType,
	payload,
});

export const disclaimerCheckbox = payload => ({
	type: actionTypes.disclaimerCheckboxType,
	payload,
});

export const accountUpdated = payload => ({
	type: actionTypes.switchAccountType,
	payload,
});

export const setFundPools = payload => ({
	type: actionTypes.fundPoolType,
	payload,
});

export const fetchRecentGrantAgreement = payload => ({
	type: actionTypes.fetchRecentAgreementType,
	payload,
});

export const fetchSavedCharityAgreement = payload => ({
	type: actionTypes.fetchSavedCharityType,
	payload,
});

export const fetchGrantHistoryAgreement = payload => ({
	type: actionTypes.fetchGrantHistoryType,
	payload,
});

export const fetchPendingGrantAgreement = payload => ({
	type: actionTypes.fetchPendingAgreementType,
	payload,
});

export const removeCharityAgreement = (payload, successFn) => ({
	type: actionTypes.removeCharityType,
	payload,
	successFn,
});

export const selectCharityAgreement = payload => ({
	type: actionTypes.selectCharityType,
	payload,
});

export const saveGrantAgreement = (payload, successFn) => ({
	type: actionTypes.saveAgreementType,
	payload,
	successFn
});

export const advisorAddress = payload => ({
	type: actionTypes.advisorAddressAgreementType,
	payload,
});

export const setFundPoolUpdatedData = payload => ({
	type: actionTypes.fundPoolUpdatedDataType,
	payload,
});

export const saveStepOneDataInReducer = payload => ({
	type: actionTypes.saveAgreementOneDataReducerType,
	payload,
});

export const newAgreement = (payload) => ({
	type: actionTypes.newFlowType,
	payload
});

export const backReset = (payload) => ({
	type: actionTypes.resetFormType,
	payload
})


//search charity

export const charityAgreementSearched = payload => ({
	type: actionTypes.postCharitySearchType,
	payload,
});

export const agreementCitySearched = payload => ({
	type: actionTypes.postCitySearchType,
	payload
  });

  export const agreementCountySearched = payload => ({
	type: actionTypes.postCountrySearchType,
	payload
  });
  
  export const agreementCityLoader = payload => ({
	type: actionTypes.cityLoaderType,
	payload
  });
  export const agreementCountyLoader = payload => ({
	type: actionTypes.countryLoaderType,
	payload
  });  

  export const agreementShowGeminiFilter = payload => ({
	type: actionTypes.geminiFilterType,
	payload
  });

  export const agreementUpdateFromCounter = payload => ({
	type: actionTypes.updateFromCounterType,
	payload,
});

export const agreementUpdateLoadMoreCounter = payload => ({
	type: actionTypes.updateFromLoadingCounterType,
	payload,
});

export const agreementUpdatefrom = () => ({
	type: actionTypes.updateFromType,
});
  
export const agreementEinData = payload => ({
	type: actionTypes.einDataType,
	payload,
});

export const agreementGeminiEinData = payload => ({
	type: actionTypes.geminiEINDataType,
	payload,
});

export const agreementPostSavedCharity = (payload, successFn) =>({
	type:actionTypes.saveCharityType,
	payload,
	successFn
});

export const agreementSearchGemini = payload => ({
	type: actionTypes.searchGeminiType,
	payload
});

export const agreementPostSavedGemini = (payload, successFn) => ({
	type: actionTypes.postGeminiSavedDataType,
	payload,
	successFn
});

export const editSet = payload => ({
	type: actionTypes.enableEditType,
	payload
});

export const editReset = payload => ({
	type: actionTypes.resetEditType,
	payload
});

export const postSubmitApi = payload => ({
	type: actionTypes.confirmationPageType,
	payload
});

export const getPoolsAllocation = payload => ({
	type: actionTypes.fetchPoolsType,
	payload
});

export const getGaSpawn = payload => ({
	type: actionTypes.fetchSpawnsType,
	payload
});

export const addCharity = (payload, selectedCharity, successFn) => ({
  type: actionTypes.addCharityType,
  payload,
  selectedCharity,
  successFn
});

export const cancelSaveCharity = (payload) => ({
  type: actionTypes.cancelSavedCharityType,
  payload
});

export const gaClearAllFilters = (payload) => ({
	type: actionTypes.clearAllReducerType,
	payload
  });

  export const gaClearAllGeminiFilters = (payload) => ({
	type: actionTypes.clearAllGeminiFilterType,
	payload
  });
  

  export const grantAgreementSearchTerm = payload => ({
	type: actionTypes.searchTermType,
	payload
  });  

  export const grantAgreementGeminiSearchTerm = payload => ({
	type: actionTypes.geminiSearchTermType,
	payload
  }); 

  